import { useDispatch } from 'react-redux';
import { setRedirectAutomaticallyToAllEvents } from '@xmatters/redux/actions/allEvents';

export const useRedirectAutomaticallyToAllEvents = () => {
  const dispatch = useDispatch();
  return args => dispatch(setRedirectAutomaticallyToAllEvents(args));
};
